import React from 'react';

// Styles & Assets
import styles from './LineSeparator.module.css';

// Interfaces
interface Props {
    text: string
}

const LineSeparator: React.FC<Props> = ({ text }) => {

    return (
        <div className={styles.separator}>
            <hr className={styles.sideBars}></hr>
            <p>{text}</p>
            <hr className={styles.sideBars}></hr>
        </div>
    );
};

export default LineSeparator;